import { gql } from 'graphql-request';

export const GQLStitchQuery = gql`
query stitchLink ($pathName: String!) {
    stitchLink(linkId: $pathName) {
            redirectUrl
    }
}
`;